import { render } from "./InterviewLayout.vue?vue&type=template&id=72098572&scoped=true"
import script from "./InterviewLayout.vue?vue&type=script&lang=js"
export * from "./InterviewLayout.vue?vue&type=script&lang=js"

import "./InterviewLayout.vue?vue&type=style&index=0&id=72098572&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72098572"]])

export default __exports__